import * as React from 'react';

import { Button, Dialog, Typography2 } from '@coursera/cds-core';

import _t from 'i18n!nls/enterprise-admin-learners';

const { HeadingGroup, Content, Actions } = Dialog;

export type InviteErrorDialogProps = { open: boolean; onClose: () => void };

/** Generic error card for a total failure — no `failed[]` detail is available for this case. */
const InviteErrorDialog = ({ open, onClose }: InviteErrorDialogProps) => (
  <Dialog open={open} onClose={onClose} width="large">
    <HeadingGroup>{_t('Something went wrong')}</HeadingGroup>
    <Content>
      <Typography2 component="p">{_t("We couldn't send invitations. Please try again.")}</Typography2>
    </Content>
    <Actions>
      <Button variant="primary" onClick={onClose}>
        {_t('Done')}
      </Button>
    </Actions>
  </Dialog>
);

export default InviteErrorDialog;
